// extracted by mini-css-extract-plugin
export default {"component":"CheckerUsp__component-kK9H"};